/* eslint-disable max-lines-per-function */
import { isObject } from "../core";
import { STORE_BASE_PATH } from "../config";

export const toQueryString = (params = {}) =>
  Object.keys(params)
    .map(k => {
      if (Array.isArray(params[k])) {
        return params[k]
          .map(val => `${encodeURIComponent(k)}[]=${encodeURIComponent(val)}`)
          .join("&");
      }
      const value = isObject(params[k]) ? JSON.stringify(params[k]) : params[k];
      return `${encodeURIComponent(k)}=${encodeURIComponent(value)}`;
    })
    .join("&");

export const objectToQueryString = objToStr => {
  const recursionParams = (params = {}, prefix = "") => {
    if (typeof params !== "object") return `${prefix}=${encodeURIComponent(params)}&`;

    let result = "";
    Object.keys(params).forEach(param => {
      const serialize = (o, i) => `${i !== "" ? "[" : ""}${o}${i !== "" ? "]" : ""}`;
      const key = `${prefix}${serialize(param, prefix)}`;
      if (isObject(params[param])) {
        result += recursionParams(params[param], `${key}`);
      } else if (Array.isArray(params[param])) {
        params[param].forEach((item, body) => {
          result += recursionParams(item, `${key}[${body}]`);
        });
      } else {
        result += `${key}=${encodeURIComponent(params[param])}&`;
      }
    });
    return result;
  };

  return recursionParams(objToStr).slice(0, -1); // remove last "&"
};

export const resolvePathArgs = (path, args) => {
  const shouldHaveReplacements = path.includes(":");
  let replacements;
  let data;
  let options;

  if (shouldHaveReplacements) {
    [replacements, data, options = { raw: false }] = args;
    if (!replacements) {
      throw new Error(`Please provide attributes for path: ${path}`);
    }
  } else {
    [data, options = { raw: false }] = args;
  }

  return { shouldHaveReplacements, data, options, replacements };
};

export const makePath = (path, { replacements, params }) => {
  let newPath = String(path);

  if (replacements) {
    if (!isObject(replacements)) {
      throw new Error(
        `Replacements need to be object, ${typeof replacements} provided for ${path}`
      );
    }

    Object.keys(replacements).forEach(name => {
      if (newPath.includes(`:${name}`)) {
        newPath = newPath.replace(new RegExp(`:${name}`, "g"), replacements[name]);
      } else {
        throw new Error(`Can't find :${name} in ${path}`);
      }
    });

    if (newPath.includes(":")) {
      throw new Error(`Not all replacements were provided: ${path}`);
    }
  }

  const query = params ? `?${toQueryString(params)}` : "";

  return `${newPath}${query}`;
};

export const makeFullPath = (url, options = { skipDekeo: false }) => {
  let path;
  const { base, skipDekeo } = { base: STORE_BASE_PATH, ...options };
  if (base && (base !== "/print" || !skipDekeo)) {
    path = `${base}${url}`;
  } else {
    path = url;
  }

  return path;
};
